/** Encode URL path segments so spaces (e.g. Ruijie "Frame 1.png") load in <img>/next/image. */
export function encodeRemoteImageUrl(url: string | null | undefined): string {
  if (!url) return ""
  try {
    const u = new URL(url)
    u.pathname = u.pathname
      .split("/")
      .map((seg) => {
        if (!seg) return seg
        try {
          return encodeURIComponent(decodeURIComponent(seg))
        } catch {
          return encodeURIComponent(seg)
        }
      })
      .join("/")
    return u.toString()
  } catch {
    return url.replace(/ /g, "%20")
  }
}

const HOTLINK_BLOCKED_HOST_HINTS = [
  "ruijie.com",
  "myqcloud.com",
  "eo-sgp-cos.ruijie.com",
]

/**
 * Rewrite CDN URLs that block localhost Referer through our same-origin proxy.
 */
export function toDisplayImageUrl(url: string | null | undefined): string {
  const encoded = encodeRemoteImageUrl(url)
  if (!encoded) return ""

  try {
    const host = new URL(encoded).hostname.toLowerCase()
    const needsProxy = HOTLINK_BLOCKED_HOST_HINTS.some(
      (hint) => host === hint || host.endsWith(`.${hint}`) || host.includes(hint)
    )
    if (!needsProxy) return encoded
    return `/api/image-proxy?u=${encodeURIComponent(encoded)}`
  } catch {
    return encoded
  }
}
